// SPDX-License-Identifier: AGPL-3.0-or-later

import {isCommand, type ParsedCommand, parseCommand} from '@app/features/devtools/utils/CommandUtils';
import type {LexicalMessageCommandResolution} from '@app/features/messaging/utils/MessageCommandResolution';
import {LexicalMessageCommandResolutionStatus} from '@app/features/messaging/utils/MessageCommandResolution';
import {parseInlineTextCommand} from '@app/features/messaging/utils/MessageInlineCommandUtils';

export function resolveSubmittedMessageCommand(
	wireContent: string,
	lexicalResolution: LexicalMessageCommandResolution | null,
): ParsedCommand | null {
	if (lexicalResolution === null) {
		return isCommand(wireContent) ? parseCommand(wireContent) : null;
	}
	if (lexicalResolution.status === LexicalMessageCommandResolutionStatus.VALID_COMMAND) {
		return lexicalResolution.command;
	}
	if (lexicalResolution.status === LexicalMessageCommandResolutionStatus.INVALID_COMMAND) {
		return null;
	}
	return parseInlineTextCommand(wireContent);
}
